<template>
  <div>
    <autoLogout />
    <loader :loader="sending" />
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)" />
      <v-card v-if="showAction(1)">
        <v-card-text>
          <v-row align="baseline" justify="center" class="pb-4">
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field
            ></v-col>
            <v-col
              cols="12"
              md="4"
              xl="2"
              sm="12"
              @click="changeAction(2)"
              v-if="$utilFront.withPermission($prm.MODULE_CONF)"
            >
              <btn-accion :elements="btnAdd" />
            </v-col>
          </v-row>
        </v-card-text>

        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :items-per-page="10"
          :footer-props="{
            'items-per-page-text': 'Elementos por página',
            'items-per-page-all-text': 'Todo',
          }"
          no-results-text="Sin resultados coincidentes con el búsqueda"
          loading-text="Cargando..."
          no-data-text="Sin resultados disponibles"
          class="mx-5"
          dense
          fixed-header
          height="auto"
        >
          <template v-slot:[`item.status`]="{ item }">
            <v-btn
              icon
              @click.native.prevent.stop.capture="editarStatus(item)"
              v-if="
                $utilFront.withPermission($prm.UPDATE_STATUS_CONSULTING_ROOM)
              "
            >
              <v-switch v-model="item.status" color="success"></v-switch>
            </v-btn>
            <span
              v-else
              :class="{
                'error--text': !item.status,
                'success--text': item.status,
              }"
            >
              {{ item.status ? "Activo" : "Inactivo" }}
            </span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip top v-if="$utilFront.withPermission($prm.MODULE_CONF)">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="checkPermission(item)">
                  <v-icon color="blue" v-bind="attrs" v-on="on">
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
              <span>Editar información</span>
            </v-tooltip>
            <span v-else> - - - </span>
          </template>
        </v-data-table>
      </v-card>
      <encabezado
        :elementos="encabezado"
        v-if="showAction(2) || showAction(3)"
      />
      <v-card v-if="showAction(2) || showAction(3)">
        <validation-observer ref="form" v-slot="{ invalid }">
          <v-form @submit.prevent="doAction">
            <div class="container">
              <v-row>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Nombre de permiso"
                    rules="required|max:50"
                  >
                    <v-text-field
                      v-model="dataModal.name"
                      :counter="50"
                      :error-messages="errors"
                      label="Nombre de Permiso"
                      required
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Descripción"
                    rules="required|max:150"
                  >
                    <v-text-field
                      v-model="dataModal.description"
                      :counter="150"
                      :error-messages="errors"
                      label="Descripción"
                      autocomplete="off"
                      required
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Path"
                    rules="max:150"
                  >
                    <v-text-field
                      v-model="dataModal.path"
                      :counter="150"
                      :error-messages="errors"
                      label="Path"
                      autocomplete="off"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Tipo de Permiso"
                    rules="required"
                  >
                    <v-autocomplete
                      v-model="dataModal.type"
                      label="Tipo de Permiso"
                      :items="types"
                      :item-text="types.text"
                      :item-value="types.value"
                      :error-messages="errors"
                    >
                    </v-autocomplete>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Módulo"
                    rules="required"
                  >
                    <v-autocomplete
                      v-if="showAction(2)"
                      v-model="dataModal.module"
                      label="Módulo"
                      :items="listModule"
                      :item-text="listModule.text"
                      :item-value="listModule.value"
                      :error-messages="errors"
                    >
                    </v-autocomplete>
                    <v-autocomplete
                      v-if="showAction(3)"
                      v-model="dataModal.module.idModule"
                      label="Módulo"
                      :items="listModule"
                      :item-text="listModule.text"
                      :item-value="listModule.value"
                      :error-messages="errors"
                    >
                    </v-autocomplete>
                  </validation-provider>
                </v-col>
              </v-row>
            </div>
            <div class="d-flex justify-center">
              <v-col class="d-flex justify-space-around">
                <div v-on:click="changeAction(1)">
                  <btn-accion :elements="btnCancell" />
                </div>
                <v-btn
                  type="submit"
                  :disabled="sending || invalid"
                  color="success"
                >
                  <v-icon left>{{ iconoAdd }}</v-icon>
                  {{ textoAdd }}
                </v-btn>
              </v-col>
            </div>
          </v-form>
        </validation-observer>
      </v-card>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Datatable from "../../components/Datatable.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../../components/Sidebar";
import BtnAccion from "../../components/btnAccion.vue";
import AutoLogout from "../../components/AutoLogout.vue";
import { PermissionRequest, ModuleRequest } from "@/core/request";
import { required, max } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import { mapActions } from "vuex";
import ExportImportBtn from "../../components/ExportImportBtn.vue";
import Loader from "../../components/Loader.vue";
setInteractionMode("eager");
extend("required", {
  ...required,
  message: "{_field_} no puede quedar vacío",
});
extend("max", {
  ...max,
  message: "{_field_} no debe ser mayor de {length} caracteres",
});

export default {
  name: "Perfiles",
  components: {
    Sidebar,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    Datatable,
    BtnAccion,
    AutoLogout,
    ExportImportBtn,
    Loader,
  },
  data() {
    return {
      importDialog: false,
      dialog: false,
      search: "",
      dataModal: {},
      action: 1,
      encabezado: {
        icono: "mdi-menu",
        texto: "Permisos",
      },
      list: [],
      listModule: [],
      sending: false,
      dialogs: {
        title: "¿Desea modificar el estatus?",
        text:
          "La permiso será habilitado / inhabilitado de inmediato y podría afectar a los registros que dependan de él",
      },
      headers: [
        { text: "ID Permiso", value: "idPermission" },
        { text: "Nombre", value: "name" },
        { text: "Descripción", value: "description" },
        { text: "Módulo", value: "module.name" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      btnAdd: {
        icon: "mdi-plus",
        text: "Agregar Permiso",
        tooltip: "Agregar Permiso",
      },
      btnCancell: {
        icon: "mdi-close",
        text: "Cancelar registro",
        tooltip: "Cancelar registro",
        color: "error",
      },
      iconoAdd: "mdi-plus",
      textoAdd: "Registrar permiso",
      service: PermissionRequest,
      updateModal: false,
      results: {},
      fileXls: null,
      types: [
        { text: "Permiso simple", value: 1 },
        { text: "Permiso de Módulo", value: 2 },
      ],
    };
  },
  created() {},
  mounted() {
    this.validBrowserTab();
    this.listAll();
    this.listModules();
  },
  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    catchError: (e) => {
      //console.log(e);
      this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
    },
    showAction(action) {
      return this.action == action;
    },
    editarStatus(item) {
      this.dialog = true;
      this.dataModal = Object.assign(this.dataModal, item);
    },
    changeAction(action) {
      if (action == 1) {
        this.$refs.form.reset();
        this.dataModal = {};
      } else if (action == 2) {
        this.dataModal = {};
      } else if (action == 3) {
      }
      this.action = action;
      this.checkEncabezado();
    },
    checkEncabezado() {
      switch (this.action) {
        case 1:
          this.encabezado = {
            icono: "mdi-menu",
            texto: "Permisos",
          };
          this.dialogs = {
            title: "¿Desea modificar el estatus?",
            text:
              "La permiso será habilitado / inhabilitado de inmediato y podría afectar a los registros que dependan de él",
          };
          break;
        case 2:
          this.encabezado = {
            icono: "mdi-menu",
            texto: "Registrar permiso",
          };
          this.dialogs = {
            title: "¿Desea registrar éste permiso?",
            text:
              "La permiso será registrado de inmediato y estará disponible en el sistema",
          };
          this.iconoAdd = "mdi-plus";
          this.textoAdd = "Registrar permiso";
          this.btnCancell = {
            icon: "mdi-close",
            text: "Cancelar registro",
            tooltip: "Cancelar registro",
            color: "error",
          };
          break;
        case 3:
          this.encabezado = {
            icono: "mdi-menu",
            texto: "Editar permiso",
          };
          this.dialogs = {
            title: "¿Desea modificar éste permiso?",
            text:
              "La permiso será modificado de inmediato y podría afectar a los registros que dependan de él",
          };
          this.iconoAdd = "mdi-reload";
          this.textoAdd = "Editar permiso";
          this.btnCancell = {
            icon: "mdi-close",
            text: "Cancelar Modificación",
            tooltip: "Cancelar Modificación",
            color: "error",
          };
          break;
        default:
          this.encabezado = {
            icono: "mdi-menu",
            texto: "Permisos",
          };
          break;
      }
    },
    doAction() {
      if (this.$refs.form.validate()) {
        // this.dialog = true;
        if (this.action == 2) {
          this.add();
        } else if (this.action == 3) {
          this.update();
        }
      }
    },
    sendData() {
      this.sending = !this.sending;
    },

    listModules() {
      ModuleRequest.all().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.listModule = res.data.data.map((module) => {
            return {
              value: module.idModule,
              text: module.name,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },

    listAll() {
      this.service.listAll().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.list = res.data.data.map((permission) => {
            return {
              idPermission: permission.idPermission,
              name: permission.name,
              module: permission.module,
              description: permission.description,
              path: permission.path,
              type: permission.type,
            };
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    add() {
      if (!this.sending) {
        this.sending = true;
        let postData = {
          name: this.dataModal.name.trim(),
          description: this.dataModal.description
            ? this.dataModal.description.trim()
            : "",
          path: this.dataModal.path ? this.dataModal.path.trim() : "",
          type: this.dataModal.type,
          module: {
            idModule: this.dataModal.module,
          },
        };
        PermissionRequest.add(postData)
          .then((res) => {
            this.listAll();
            if (res.data.code === 200) {
              this.$utilFront.notifications(
                "Permiso registrado correctamente",
                "SUCCESS"
              );
              this.changeAction(1);
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(res.data.data, "ERROR");
            }
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
    update() {
      if (!this.sending) {
        this.sending = true;
        let postData = {
          idPermission: this.dataModal.idPermission,
          name: this.dataModal.name.trim(),
          description: this.dataModal.description
            ? this.dataModal.description.trim()
            : "",
          path: this.dataModal.path ? this.dataModal.path.trim() : "",
          type: this.dataModal.type,
          module: {
            idModule: this.dataModal.module.idModule,
          },
        };
        PermissionRequest.update(postData)
          .then((res) => {
            this.listAll();
            if (res.data.code === 200) {
              this.$utilFront.notifications(
                "Permiso modificado correctamente",
                "SUCCESS"
              );
              this.changeAction(1);
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(res.data.data, "ERROR");
            }
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },

    checkPermission(item) {
      this.dataModal = Object.assign(this.dataModal, item);
      this.changeAction(3);
    },
  },
  computed: {},
};
</script>
